import React from "react";

interface FlameIconProps {
  streakCount: number;
  redeemAvailable: boolean;
  isEnabled: boolean;
  onClick: () => void;
}

export const FlameIcon: React.FC<FlameIconProps> = ({
  streakCount,
  redeemAvailable,
  isEnabled,
  onClick,
}) => {
  // Determine state
  const isInactive = !isEnabled || streakCount === 0;

  const getContainerClass = () => {
    if (isInactive) {
      return "bg-gray-700/50 opacity-50";
    }
    if (redeemAvailable) {
      return "bg-gradient-to-br from-yellow-400 to-orange-500 shadow-lg shadow-orange-500/50 animate-pulse";
    }
    return "bg-gradient-to-br from-orange-400 to-red-500 shadow-md shadow-orange-400/40";
  };

  return (
    <button
      onClick={onClick}
      className={`relative w-12 h-12 rounded-full flex items-center justify-center cursor-pointer transition-all hover:scale-110 active:scale-95 ${getContainerClass()}`}
    >
      {/* Flame emoji */}
      <span
        className={`text-2xl ${isInactive ? "grayscale opacity-40" : ""}`}
        style={{ filter: isInactive ? "grayscale(1)" : "none" }}
      >
        🔥
      </span>

      {/* Streak count badge */}
      {streakCount > 0 && isEnabled && (
        <div className="absolute -bottom-1 -right-1 bg-red-600 text-white text-[10px] font-bold rounded-full px-1.5 py-0.5 min-w-[20px] text-center animate-bounce">
          x{streakCount}
        </div>
      )}

      {/* Ready sparkle for redeemable */}
      {redeemAvailable && (
        <span className="absolute -top-1 -right-1 text-sm animate-spin">
          ✨
        </span>
      )}
    </button>
  );
};

export default FlameIcon;
